import classnames from 'classnames';
import * as React from 'react';

import ChatbotShapeSmile from '../assets/icons/ChatbotShapeSmile';
import { LiveChatAgent, SenderTypes } from '../store';

export interface AvatarProps {
	sender: SenderTypes;
	senderInfo?: LiveChatAgent;
}

export const Avatar: React.FC<AvatarProps> = ({ sender, senderInfo }) => {
	if (sender === SenderTypes.LiveChat && senderInfo) {
		return (
			<div
				data-testid="chatbot-agent-avatar"
				className={classnames(
					'livechat-avatar text-display-sm flex items-center justify-center relative mx-2 mb-2 rounded-full font-bold',
					{
						'bg-darkgreen text-white': senderInfo.isConnected,
						'bg-lightgreen text-darkgreen': !senderInfo.isConnected,
					}
				)}
			>
				{senderInfo.initials && (
					<React.Fragment>{senderInfo.initials.substring(0, 1)}</React.Fragment>
				)}
				<span
					data-testid={
						senderInfo.isConnected
							? 'chatbot-agent-avatar-connected'
							: 'chatbot-agent-avatar-disconnected'
					}
					className={classnames(
						'absolute top-0 right-0 rounded-full block border border-solid border-white',
						{
							'bg-ongreen': senderInfo.isConnected,
							'bg-deals': !senderInfo.isConnected,
						}
					)}
					style={{ width: '10px', height: '10px' }}
				></span>
			</div>
		);
	}

	return (
		<div
			data-testid="avatar"
			className="relative flex items-center block mx-2 my-2"
		>
			<ChatbotShapeSmile className="ico w-8 h-8" />
		</div>
	);
};

export default Avatar;
